import React from 'react';
import LoadingScreen from '../components/LoadingScreen';

const LoadingDemo = () => {
  return <LoadingScreen message="Animation d'explosion d'étoiles 💫" />;
};

export default LoadingDemo;
